// extracted by mini-css-extract-plugin
export var container = "_5y-0";
export var infoButton = "_5y-1";
export var label = "_5y-3";
export var labelExpanded = "_5y-4";
export var price = "_5y-5";
export var priceExpanded = "_5y-6";
export var title = "_5y-2";